<script>
import options from './ProfileOverlay.options'
export default options
</script>

<template>

  <div class="kb-overlay-styles__content-wrapper">

    <article class="kb-overlay-styles kb-profile-overlay">
      
      <div class="kb-overlay-styles__wrapper-for-scroll-bottom kb-profile-overlay__wrapper-for-scroll-bottom">

        <div class="kb-overlay-styles__hero kb-profile-overlay__hero">
          <div class="kb-overlay-styles__hero-wrapper kb-profile-overlay__hero-wrapper">
            <h4 class="kb-overlay-styles__hero-title kb-profile-overlay__hero-wrapper-title">{{ getLabel('title') }}</h4>

            <div class="kb-profile-overlay__hero-wrapper-block">
              <a class="kb-profile-overlay__link" :href="userInformationUrl" data-order="first" @keydown.tab="tabTrap">
                <svg class="kb-ui-icon kb-ui-icon--user" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M21.5 8.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Zm1 0a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0ZM6 26.5c0-5.523 4.477-10 10-10s10 4.477 10 10v4h1v-4c0-6.075-4.925-11-11-11s-11 4.925-11 11V30a.5.5 0 0 0 .5.5H23v-3h-1v2H6v-3Z" fill="#3C3C3C"/></svg>
                <div class="kb-profile-overlay__link-label--small">
                  {{ getLabel("userInformationLabel") }}
                </div>
                <svg class="kb-ui-icon kb-ui-icon--link kb-profile-overlay__link-icon-right" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="#3c3c3c" viewBox="0 0 17 16"><path d="m12.167 4 3.622 4-3.622 4" stroke-linejoin="round"/><path d="M11.747 8H0"/></svg>
              </a>
            </div>
          </div>

        </div>

        <div class="kb-overlay-styles__hero-curve">
          <svg role="presentation" viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z" />
          </svg>
        </div>

        <div class="kb-profile-overlay__content">

          <div class="kb-profile-overlay__content-block" v-if="fundraisingCampaigns.length > 0">
            <div class="kb-profile-overlay__content-block-title">
              {{ getLabel("yourFundraisingsLabel") }}
            </div>
            <template v-for="campaign, index in fundraisingCampaigns" :key="index">
              <a class="kb-profile-overlay__link" :href="campaign.url">
                <div class="kb-profile-overlay__link-label--large">
                  {{ campaign.name }}
                </div>
                <div class="kb-ui-icon kb-ui-icon--ui-link kb-profile-overlay__link-icon-right"></div>
              </a>
            </template>
          </div>
  
          <div class="kb-profile-overlay__content-block" v-if="hasFrivilligOrder">
            <div class="kb-profile-overlay__content-block-title">
              {{ getLabel("yourOrdersLabel") }}
            </div>
            <a class="kb-profile-overlay__link" :href="frivilligOrdersUrl">
              <div class="kb-profile-overlay__link-label--large">
                {{ getLabel("frivilligOrdersLabel") }}
              </div>
              <div class="kb-ui-icon kb-ui-icon--ui-link kb-profile-overlay__link-icon-right"></div>
            </a>
          </div>
          
          <hr v-if="(fundraisingCampaigns.length > 0 || hasFrivilligOrder) && (hasFrivilligProfile || hasCancerforumProfile || hasStafetForLivetProfile)" />
          
          <div v-if="hasFrivilligProfile || hasCancerforumProfile || hasStafetForLivetProfile" class="kb-profile-overlay__content-block">
            <div class="kb-profile-overlay__content-block-title">
              {{ getLabel("goToLabel") }}
            </div>
  
            <a class="kb-profile-overlay__link" :href="frivilligUrl" v-if="hasFrivilligProfile">
              <div class="kb-profile-overlay__link-label--small">
                {{ getLabel("frivilligLabel") }}
                <template v-if="hasFrivilligNotification">
                  <p class="kb-visually-hidden">{{ getLabel('frivilligNotificationHelpText') }}</p>
                  <div class="kb-profile-overlay__link-label-notification-dot"></div>
                </template>
              </div>
              <div class="kb-ui-icon kb-ui-icon--ui-link kb-profile-overlay__link-icon-right"></div>
            </a>
            
            <a class="kb-profile-overlay__link" :href="cancerforumUrl" v-if="hasCancerforumProfile">
              <div class="kb-profile-overlay__link-label--small">
                {{ getLabel("cancerforumLabel") }}
                <template v-if="hasCancerforumNotification">
                  <p class="kb-visually-hidden">{{ getLabel('cancerforumNotificationHelpText') }}</p>
                  <div class="kb-profile-overlay__link-label-notification-dot"></div>
                </template>
              </div>
              <div class="kb-ui-icon kb-ui-icon--ui-link kb-profile-overlay__link-icon-right"></div>
            </a>
  
            <a class="kb-profile-overlay__link" :href="stafetForLivetUrl" v-if="hasStafetForLivetProfile">
              <div class="kb-profile-overlay__link-label--small">
                {{ getLabel("stafetForLivetLabel") }}
              </div>
              <div class="kb-ui-icon kb-ui-icon--ui-link kb-profile-overlay__link-icon-right"></div>
            </a>
          </div>

        </div>
        
        <a class="kb-profile-overlay__logout" :href="logoutUrl" data-order="last" @keydown.tab="tabTrap">
          <button class="kb-button">
            {{ getLabel("logoutLabel") }}
            <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5 5.25C14.5 2.76472 12.4853 0.75 10 0.75C7.51472 0.75 5.5 2.76472 5.5 5.25V7.5H6.25V5.25C6.25 3.17893 7.92893 1.5 10 1.5C12.0711 1.5 13.75 3.17893 13.75 5.25V9.75H0.25V23.25H16.75V21H16V22.5H1V10.5H19V23.25H19.75V9.75H14.5V5.25ZM8.125 14.625C8.125 13.5895 8.96447 12.75 10 12.75C11.0355 12.75 11.875 13.5895 11.875 14.625C11.875 15.3185 11.4986 15.9246 10.9372 16.2494L10.75 16.3577V19.5H9.25V16.3577L9.06277 16.2494C8.50136 15.9246 8.125 15.3185 8.125 14.625ZM10 12C8.55025 12 7.375 13.1753 7.375 14.625C7.375 15.5175 7.82057 16.3055 8.5 16.7794V20.25H11.5V16.7794C12.1794 16.3055 12.625 15.5175 12.625 14.625C12.625 13.1753 11.4497 12 10 12Z" fill="#C60001"/>
            </svg>
          </button>
        </a>

      </div>

    </article>

  </div>
</template>
